import React, { Component } from 'react';
import { FormGroup, Input, Button, Container } from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';
import { notificacion } from '../../utilitarios/util';
import { connect } from 'react-redux';
import { Logo, ArrowRight, ArrowBack, CurveTop } from '../../assets/icons/svgIcon';
import { SvgAssets } from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';
import { generarMAC, login, validuserlogin, generarInicioMAC } from '../../store/sagas/authApi';
import localStorageCustom from '../../utilitarios/localStorage';
import { AuthContext } from "../../store/provider/AuthProvider";
import device from '../../utilitarios/device';
import { getDevice } from '../../store/sagas/utilApi';
import { data } from '../../constants/Constants';
import FormFeedback from 'reactstrap/lib/FormFeedback';
import Platform from 'react-platform-js';
import Spinner from "../reusable/Loader";

export class Login extends Component {
  // class Login extends Component {
  static displayName = Login.name;
  static contextType = AuthContext;

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      step: 0,
      email: "",
      errorValidacion: null,
      pswChanged: false,
      password: '',
      hidePassword: true,
      icon: 'icon-eye-close',
    };
    this.checkCookie();

    this.nextStep = this.nextStep.bind(this);
    this.backStep = this.backStep.bind(this);
  }



  setCookie(cname, cvalue, exdays) {
    let d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + "";
  }


  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');

    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  checkCookie() {
    let code = this.getCookie("mc");
    console.log("code : ", code)
    if (code != "") {
      localStorage.setItem("mc", code);
    } else {

      generarInicioMAC()
        .then(result => {

          let newCode = result.token
          this.setCookie("mc", newCode, 365);
          let cookieGenerated = this.getCookie("mc");
          localStorage.setItem("mc", cookieGenerated);
        }).catch((error) => {
          console.log("error : ", error)
        });

    }
  }

  nextStep() {
    this.setState({ step: this.state.step + 1, errorValidacion: null, loading: false })
  }

  backStep() {
    this.setState({ step: this.state.step - 1, errorValidacion: null, loading: false }
      //   , () => {

      //   if (this.props.location.state != null) {
      //     if (this.props.location.state.step != null) {
      //       this.props.location.state = { step: this.state.step };
      //     }
      //   }
      // }
    )
  }

  checkParams() {
    this.validPswChanged();
    this.validStep();
  }

  putEmail = (e) => {
    let value = e.currentTarget.value;
    this.setState({ email: value, errorValidacion: null })
  }

  putPassword = (e) => {
    let value = e.currentTarget.value;
    this.setState({ password: value, errorValidacion: null })
  }

  validPswChanged() {
    if (this.props.location.state != null) {
      let pswChanged = this.props.location.state.pswChanged;
      if (pswChanged != null) this.setState({ pswChanged: pswChanged });
    }
  }

  validStep() {
    if (this.props.location.state != null) {
      let step = this.props.location.state.step;
      if (step != null) this.setState({ step: step }, () => {
        this.props.history.replace();
      });
    }
  }

  changeIcon() {
    this.setState(prevState => ({
      icon: prevState.icon == 'icon-eye' ? 'icon-eye-close' : 'icon-eye',
      hidePassword: !prevState.hidePassword
    }))
  }

  postLogin = async (signIn) => {
    const auth = this.context;
    let Contrasenia = this.state.password;
    let CorreoElectronico = this.state.email;
    this.setState({ loading: true });

    login({ CorreoElectronico, Contrasenia })
      .then(result => {
        let storageGeneral = {
          dealer: {},
          linea: [],
          asociado: []
        }
        if (result.mo.type == "success") {
          localStorageCustom.prototype.saveToken(result.token);
          storageGeneral.dealer = result.dto;
          localStorageCustom.prototype.saveRazonSocial(storageGeneral.dealer.razsocialSocial);
          localStorageCustom.prototype.saveUsuario(storageGeneral);
          this.setState({ loading: false });
          console.log(this.state.linea);
          auth.setIsLoggedIn(true);
          this.props.history.push({
            pathname: '/linea-negocio',
            state: {
              LineaNegocio: this.state.linea
            }
          });
          signIn(result.token);
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Login", error.message ?? null);
        });
      });
  }

  postValidLogin = async (signIn, setCodigoDispositivo) => {
    let CorreoElectronico = this.state.email;
    this.setState({ loading: true });
    const { OS, OSVersion, Browser, BrowserVersion } = Platform;
    
    let descripcion = `${OS} ${OSVersion} / ${Browser} ${BrowserVersion}`
    validuserlogin({ CorreoElectronico, descripcion })
      .then(result => {
        console.log("result : ", result)
        if (result.mo.type == "success") {
          device.prototype.Mac = result.dto.codigoDispositivo;
          if (result.dto.solicitudCuenta.estadoSolicitudId == 22)  ///EstadoActivado
            this.setState({ password: '' }, this.nextStep);
          else {
            this.setState({ loading: false });

            this.props.history.push({
              pathname: 'verificar-correo',
              state: {
                email: CorreoElectronico,
                errorValidacion: result.dto.solicitudCuenta.estadoSolicitud
              }
            });

          }

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false, errorValidacion: error.message ?? null }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          notificacion("Login", error.message ?? null);
        });
      });

  }

  Bienvenida() {
    return (
      <div className="login_content">
        <div className="content">
          <img className='logo' src={require('../../assets/img/logo-1.png')} />
          {/* <h4 className='title-2'>Crosland B2B</h4>
          <p>La herramienta que brinda mayor conexión y eficiencia entre Crosland y sus clientes</p> */}
          <button className='btn-block red' onClick={() => { this.setState({ email: '' }, this.nextStep) }}>iniciar sesión</button>
          {/* <button className='btn-block red' onClick={this.nextStep}>iniciar sesión</button> */}
        </div>
        <div className="text-center">
          <Link className="link-u" to="/solicitar-acceso" style={{ color: "#fff" }}>Solicita Acceso</Link>
        </div>
      </div>
    )
  }

  componentDidMount() {

    const { history } = this.props;

    if (localStorageCustom.prototype.getToken() != null) {
      this.props.history.push('/linea-negocio');
    }
    this.checkParams();
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.location.state != undefined) {
      if (prevProps.location.state !== this.props.location.state) {
        this.checkParams();
      }
    }
    // notificacion("Login", "dnmjkdfv fjvdfijvdf nijvd");
  }

  IngresarEmail() {
    let email = this.state.email;
    const auth = this.context;
    const pswChanged = this.state.pswChanged;
    let errorValidacion = this.state.errorValidacion;

    return (
      <Container>
        <Button color="link" className="btn-back mobile" onClick={this.backStep}><SvgAssets icon="icon-back" fill="#fff" /></Button>
        <div className="text-center">
          <img className='logo-small' src={require('../../assets/img/logo-1.png')} />
        </div>
        <div className="card text-center card_login">
          {/* <img className='logo-small desktop' src={require('../../assets/img/logo-1.png')} /> */}
          <Button color="link" className="btn-back desktop" onClick={this.backStep}>
            <SvgAssets icon="icon-back" fill={c.celeste} />
          </Button>
          <SvgAssets icon="curve-top" className='curve-card-login mobile' fill="#fff" />
          <h4 className='title-2 desktop'>Ingresa a tu cuenta</h4>
          <FormGroup style={{ marginBottom: 30 }}>
            <Input type="email" name="email" placeholder="Email" value={this.state.email} onChange={this.putEmail}
              onKeyUp={(e) => e.keyCode == 13 && email != '' ? pswChanged ? this.props.history.push('verificar-correo') : this.postValidLogin(auth.setuserToken, auth.setCodigoDispositivo) : null}
            />
            {errorValidacion ?
              <FormFeedback className="text-danger" style={{ display: "inherit" }}>{errorValidacion}</FormFeedback> : null
            }
          </FormGroup>
          <button disabled={email == ""}
            className={`btn-block red${(email == "") ? ' disabled' : ''}`}
            onClick={() => pswChanged ? this.props.history.push('verificar-correo') : this.postValidLogin(auth.setuserToken, auth.setCodigoDispositivo)}
          >siguiente<ArrowRight className='svg-right' />
          </button>
          <Link className="link-u mt-5" to="/recuperar-contrasenia">¿Olvidaste tu contraseña?</Link>
        </div>
        <div className="text-center mt-4">
          <span>Si aún no tienes una cuenta,</span>
          <Link className="link-u" to="/solicitar-acceso" style={{ color: "#fff" }}>Solicita Acceso</Link>
        </div>
      </Container>
    )
  }

  IngresarPassword() {
    const auth = this.context;
    let { password, hidePassword, icon } = this.state;

    return (
      <Container>
        <Button color="link" className="btn-back mobile" onClick={this.backStep}><ArrowBack className='svg' /></Button>
        <div className="text-center">
          <img className='logo-small' src={require('../../assets/img/logo-1.png')} />
        </div>
        <div className="card text-center card_login">
          <Button color="link" className="btn-back desktop" onClick={this.backStep}>
            <SvgAssets icon="icon-back" fill={c.celeste} />
          </Button>
          <SvgAssets icon="curve-top" className='curve-card-login mobile' fill="#fff" />
          <h4 className='title-2 desktop'>Ingresa a tu cuenta</h4>
          <FormGroup style={{ marginBottom: 30 }} className="icon">
            <Input type={hidePassword ? "password" : "text"} name="password" placeholder="Contraseña" value={this.state.password} onChange={this.putPassword}
              onKeyUp={(e) => e.keyCode == 13 && password != '' ? this.postLogin(auth.setuserToken) : null}
            />
            <button className="btn-icon" onClick={() => this.changeIcon()}>
              <SvgAssets icon={icon} fill={c.celeste} />
            </button>
          </FormGroup>
          <button disabled={password == ""}
            className={`btn-block red${((password == "") ? ' disabled' : '')}`}
            onClick={() => this.postLogin(auth.setuserToken)}
          >siguiente<ArrowRight className='svg-right' />
          </button>
          <Link className="link-u mt-5" to="/recuperar-contrasenia">¿Olvidaste tu contraseña?</Link>
        </div>
        <div className="text-center mt-4">
          <span>Si aún no tienes una cuenta,</span>
          <Link className="link-u" to="/solicitar-acceso" style={{ color: "#fff" }}>Solicita Acceso</Link>
        </div>
      </Container>
    )
  }

  renderStep() {
    switch (this.state.step) {
      case 0:
        return this.Bienvenida();
      case 1:
        return this.IngresarEmail();
      case 2:
        return this.IngresarPassword();
      default:
        return this.Bienvenida();
    }
  }

  render() {
    return (
      <div className="login_section">
        <Spinner visible={this.state.loading} />
        {this.renderStep()}
      </div>
    );
  }
}

